<template>
  <div class="fixed top-5 right-5 z-50 flex flex-col gap-3">
    <transition-group name="toast" tag="div">
      <div
        v-for="msg in messages"
        :key="msg.id"
        class="flex items-center gap-3 rounded-xl shadow-lg px-4 py-3 min-w-[280px] max-w-sm text-white"
        :class="msg.type === 'error' ? 'bg-gradient-to-r from-red-600 to-red-400' : 'bg-gradient-to-r from-green-600 to-green-400'"
      >
        <!-- آیکون -->
        <div class="flex items-center justify-center w-8 h-8 rounded-full bg-white/20">
          <span v-if="msg.type === 'error'">⚠️</span>
          <span v-else>✅</span>
        </div>

        <!-- متن -->
        <span class="flex-1 text-sm font-medium">{{ msg.text }}</span>

        <!-- دکمه بستن -->
        <button
          @click="removeMessage(msg.id)"
          class="text-white hover:text-gray-200 text-lg font-bold"
        >
          ×
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

let idCounter = 0;

export default {
  name: "GpsToast",
  data() {
    return {
      messages: [],
    };
  },
  computed: {
    ...mapState({
      gpsError: (state) => state.locationError,
    }),
  },
  watch: {
    gpsError(newVal) {
      if (newVal) {
        this.addMessage(newVal, "error");
      }
    },
  },
  methods: {
    ...mapMutations(["CLEAR_LOCATION_ERROR"]),
    addMessage(text, type = "error") {
      const id = idCounter++;
      this.messages.push({ id, text, type });

      // بعد ۵ ثانیه خودکار حذف میشه
      setTimeout(() => this.removeMessage(id), 5000);
    },
    removeMessage(id) {
      this.messages = this.messages.filter((m) => m.id !== id);
      this.CLEAR_LOCATION_ERROR();
    },
  },
};
</script>

<style>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.4s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}
.toast-enter-to {
  opacity: 1;
  transform: translateX(0);
}
.toast-leave-from {
  opacity: 1;
  transform: translateX(0);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
